import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pic_black",
  "use": "icon-pic_black-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol viewBox=\"0 0 14 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pic_black\">\n<rect x=\"1.75\" y=\"2.25\" width=\"10.5\" height=\"10.5\" rx=\"1\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol